import { useMemo } from 'react';

import cn from 'classnames';

import { useImage } from 'hooks/useImage';

import { Image } from 'ui/atoms/Image';

import styles from './TestimonialCard.module.scss';

const baseClass = 'testimonial-card';

export type Props = {
  avatar: string;
  logo: string;
  name: string;
  description: string;
  className?: string;
  role?: string;
};

export const TestimonialCard = ({ avatar, name, role, logo, description, className }: Props) => {
  const { buildUrl } = useImage();

  const buildSrc = useMemo(() => buildUrl({ src: `img/customers/${logo}`, width: 54, height: 54 }), [buildUrl, logo]);

  return (
    <div className={cn(styles[`${baseClass}-wrapper`], className)}>
      <div className={styles[`${baseClass}-avatar-container`]}>
        <Image
          className={styles[`${baseClass}-avatar`]}
          width={110}
          height={110}
          src={`img/testimonial/${avatar}`}
          alt={name}
        />
      </div>

      <p className={styles[`${baseClass}-description`]}>{description}</p>

      <div className={styles[`${baseClass}-company`]}>
        <div className={styles[`${baseClass}-company-logo`]} style={{ backgroundImage: `url(${buildSrc})` }}></div>

        <div className={styles[`${baseClass}-company-info`]}>
          <strong>{name}</strong>
          <span>{role}</span>
        </div>
      </div>
    </div>
  );
};
